import React from "react";
import './Form.css'
function FormHeader(){

     return(
          <div className="form">
                <h5 className="h5">Join our Newsletter</h5>
                <p className="pap">Get up to date news and information about pets</p>

          </div>
           
     )
}
export default FormHeader;